import React from 'react';
import FeatureBadge from './FeatureBadge';
import './VersionCard.css';

const VersionCard = ({ 
  title, 
  description, 
  badges = [], 
  features = [], 
  buttonText, 
  buttonUrl, 
  isExternal = false,
  variant = 'default'
}) => {
  const handleClick = (e) => {
    // Analytics tracking if needed
    if (typeof window !== 'undefined' && window.gtag) {
      const eventName = isExternal ? 'homepage_click_v1' : 'homepage_click_v2';
      window.gtag('event', eventName, {
        event_category: 'homepage',
        event_label: title
      });
    }
  };

  return (
    <div className={`version-card card ${variant === 'featured' ? 'version-card--featured' : ''}`}>
      {variant === 'featured' && (
        <div className="version-card__badge">
          <span>推荐</span>
        </div>
      )}
      
      <div className="version-card__header">
        <h3 className="version-card__title">{title}</h3>
        <p className="version-card__description">{description}</p>
      </div>

      {badges.length > 0 && (
        <div className="version-card__badges">
          {badges.map((badge, index) => (
            <FeatureBadge 
              key={index} 
              text={badge} 
              variant={index % 2 === 0 ? 'primary' : 'accent'} 
            />
          ))}
        </div>
      )}

      {features.length > 0 && (
        <div className="version-card__features">
          {features.map((feature, index) => (
            <div key={index} className="version-card__feature">
              <div className="version-card__feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9,11 12,14 22,4"></polyline>
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                </svg>
              </div>
              <span className="version-card__feature-text">{feature}</span>
            </div>
          ))}
        </div>
      )}

      <div className="version-card__footer">
        <a 
          href={buttonUrl}
          className={`btn ${variant === 'featured' ? 'btn-primary' : 'btn-secondary'}`}
          target={isExternal ? '_blank' : '_self'}
          rel={isExternal ? 'noopener noreferrer' : ''}
          onClick={handleClick}
        >
          {buttonText}
          {isExternal && (
            <svg 
              className="version-card__external-icon" 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <path d="m7 17 10-10"></path>
              <path d="M17 7v10"></path>
              <path d="M17 7H7"></path>
            </svg>
          )}
        </a>
      </div>
    </div>
  );
};

export default VersionCard;